import { SearchTarget } from "../enums/SearchTarget";
import { QueryType } from "../enums/QueryType";
import { CommonFunctions } from "../static/common-functions";

export class LockPayweekParam
{
    userId: any;
    companyId: any;
    startRange: Date;
    endRange: Date;
}
